<div class="container-fluid container-fluid--tab" *ngIf="student && settings && settingsEmployee" [ngStyle]="{ padding: smallLayout ? '0' : '15px', 'min-height.px': smallLayout ? '0' : 700 }">
  <div class="d-flex">
    <div class="flex-grow-1">
      <!-- Rights -->
      <div class="rights mb-5" *ngIf="_studentId != currentStudentId && !completedConversation">
        <label class="form-label fw-bold"> {{ 'development_rights' | label : 'goals' | async }} {{ student.firstName }} {{ student.lastName }} </label>
        <div class="d-flex align-items-center flex-wrap gap-3">
          <div class="form-check form-switch d-flex custom-switch">
            <input class="form-check-input cursor-pointer me-2" type="checkbox" [(ngModel)]="settingsEmployee.allowDevelopmentGoalsCreate" id="allowDevelopmentGoalsCreate" (change)="saveRights()" />
            <label class="form-check-label" for="allowDevelopmentGoalsCreate">
              {{ 'allow_development_goals_create' | label : 'goals' | async }}
            </label>
          </div>
          <div class="form-check form-switch d-flex custom-switch">
            <input class="form-check-input cursor-pointer me-2" type="checkbox" [(ngModel)]="settingsEmployee.allowDevelopmentGoalsEdit" id="allowDevelopmentGoalsEdit" (change)="saveRights()" />
            <label class="form-check-label" for="allowDevelopmentGoalsEdit">
              {{ 'allow_development_goals_edit' | label : 'goals' | async }}
            </label>
          </div>
          <div class="form-check form-switch d-flex custom-switch">
            <input class="form-check-input cursor-pointer me-2" type="checkbox" [(ngModel)]="settingsEmployee.allowDevelopmentGoalsDelete" id="allowDevelopmentGoalsDelete" (change)="saveRights()" />
            <label class="form-check-label" for="allowDevelopmentGoalsDelete">
              {{ 'allow_development_goals_delete' | label : 'goals' | async }}
            </label>
          </div>
        </div>
      </div>

      <!-- Add button -->
      <button class="btn mb-3" type="submit" (click)="addObjective(addObjectiveModal)" [disabled]="saving || editMode || !objectiveContractWrapper || !canAdd()" *ngIf="settings.allowDevelopmentGoalsCreate && !completedConversation">+ {{ 'add_development_goal' | label : 'managerdashboard' | async }}</button>

      <div class="row">
        <div class="col-12 col-lg-8">
          <ng-container *ngFor="let contract of objectiveContractWrapper">
            <ng-container *ngIf="contract.items?.length; else noresults">
              <!-- Contract header -->
              <div class="mt-4" *ngIf="(objectiveContractWrapper.length >= 1 || contract.studentId != _studentId) && !conversationGoals?.length">
                <h2>{{ contract.firstName }} {{ contract.lastName }}</h2>
                <span>{{ contract.functionName }} - {{ contract.departmentName }} ({{ contract.companyName }})</span>
              </div>

              <!-- DESKTOP: Table (hidden on mobile) -->
              <table class="table d-none d-lg-table" [ngClass]="{ smallLayout: smallLayout }">
                <thead>
                  <tr class="table_header_objectives">
                    <th class="objective_name">{{ 'name' | label : 'general' | async }}</th>
                    <th class="objective_status">{{ 'status' | label : 'general' | async }}</th>
                    <th class="objective_due_date">{{ 'due_date' | label : 'goals' | async }}</th>
                    <th class="objective_create_by_on" *ngIf="!smallLayout">{{ 'create_by_on' | label : 'goals' | async }}</th>
                    <th class="objective_actions">{{ 'actions' | label : 'general' | async }}</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let item of contract.items">
                    <!-- View row -->
                    <tr (click)="!editMode ? openObjectiveDetail(item) : ''" *ngIf="(!editMode || activeObjective?.studentIdpActivityId != item?.studentIdpActivityId) && isInCurrentConversation(item.studentIdpActivityId)" [ngClass]="{ 'active-row': item?.studentIdpActivityId == activeObjective?.studentIdpActivityId, editmode: editMode }">
                      <td class="objective_name" [title]="item.name">{{ item.name | slice : 0 : 32 }}{{ item.name.length > 32 ? '...' : '' }}</td>
                      <td class="objective_status">
                        <span class="badge" [style.backgroundColor]="getStatusClass(item.status)">
                          {{ getStatusName(item.status) | label : 'objective_widget' | async }}
                        </span>
                      </td>
                      <td class="objective_due_date">{{ item.dueDate | employeeDate | async }}</td>
                      <td class="objective_create_by_on" *ngIf="!smallLayout">
                        <div class="d-flex align-items-center">
                          <app-profile-picture class="mx-2" [title]="item.creator" [text]="item.creator" [whoId]="item.createdById" [whoKind]="item.createdByType" [width]="20"></app-profile-picture>
                          <div class="ms-3">{{ item.createDate | employeeDate | async }}</div>
                        </div>
                      </td>
                      <td class="objective_actions">
                        <a class="cursor-pointer table-icon-link" (click)="!editMode ? updateObjective($event, item) : ''" ngbTooltip="{{ 'edit' | label : 'general' | async }}" placement="top" container="body" [disableTooltip]="editMode" *ngIf="item.canUpdate">
                          <i class="far fa-fw fa-edit fs-5 accent-icon"></i>
                        </a>
                        <a *ngIf="!item.canUpdate" class="cursor-pointer table-icon-link">
                          <i class="far fa-fw fs-5 accent-icon"></i>
                        </a>
                        <a class="cursor-pointer table-icon-link" (click)="!editMode ? deleteObjective($event, item) : ''" ngbTooltip="{{ 'delete' | label : 'general' | async }}" placement="top" container="body" [disableTooltip]="editMode" *ngIf="settings.allowDevelopmentGoalsDelete && !completedConversation">
                          <i class="far fa-fw fa-trash-alt fs-5 delete-icon"></i>
                        </a>
                      </td>
                    </tr>
                    <!-- Edit row -->
                    <tr *ngIf="editMode && activeObjective.studentIdpActivityId == item.studentIdpActivityId" [ngClass]="{ 'active-row': item.studentIdpActivityId == activeObjective?.studentIdpActivityId, editmode: editMode }">
                      <td class="objective_name" [title]="item.name">{{ item.name }}</td>
                      <td>
                        <select name="status" class="form-select" [(ngModel)]="activeObjective.status" required>
                          <option [ngValue]="1">{{ 'not_started' | label : 'objective_widget' | async }}</option>
                          <option [ngValue]="2">{{ 'started' | label : 'objective_widget' | async }}</option>
                          <option [ngValue]="3">{{ 'finished' | label : 'objective_widget' | async }}</option>
                        </select>
                      </td>
                      <td>
                        <app-datepicker [date]="activeObjective.dueDate" (dateChange)="activeObjective.dueDate = $event" [inline]="true" [simple]="true" [marginBottom]="false" [small]="true"></app-datepicker>
                      </td>
                      <td *ngIf="!smallLayout">
                        <div class="d-flex align-items-center">
                          <app-profile-picture class="mx-2" [title]="item.creator" [text]="item.creator" [whoId]="item.createdById" [whoKind]="item.createdByType" [width]="20"></app-profile-picture>
                          <div class="ms-3">{{ item.createDate | employeeDate | async }}</div>
                        </div>
                      </td>
                      <td>
                        <a class="cursor-pointer table-icon-link" (click)="saveObjectiveChanges(item)" ngbTooltip="{{ 'save' | label : 'general' | async }}" placement="top" container="body">
                          <i class="far fa-fw fa-save fs-5 accent-icon"></i>
                        </a>
                        <a class="cursor-pointer table-icon-link" (click)="cancelObjectiveChanges(item)" ngbTooltip="{{ 'cancel' | label : 'general' | async }}" placement="top" container="body">
                          <i class="fas fa-fw fa-times fs-5 delete-icon"></i>
                        </a>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>

              <!-- MOBILE: Cards (hidden on desktop) -->
              <div class="d-lg-none mt-3">
                <ng-container *ngFor="let item of contract.items">
                  <div class="card card--widget mb-3">
                    <div class="card-body p-3">
                      <div class="d-flex justify-content-between align-items-center" (click)="toggleCollapseObjective(item.studentIdpActivityId, item)">
                        <div class="d-flex align-items-center">
                          <i
                            class="far fa-fw me-3 cursor-pointer transition"
                            [ngClass]="{
                              'fa-minus-square': isObjectiveExpanded(item.studentIdpActivityId),
                              'fa-plus-square': !isObjectiveExpanded(item.studentIdpActivityId)
                            }"
                            (click)="toggleCollapseObjective(item.studentIdpActivityId, item); $event.stopPropagation()"
                          ></i>
                          <h2 class="text-truncate mb-0" style="font-size: 13px; color: #555555; max-width: 220px">{{ item.name | slice : 0 : 32 }}{{ item.name.length > 32 ? '...' : '' }}</h2>
                        </div>
                        <div class="d-flex align-items-center">
                          <a class="cursor-pointer table-icon-link" (click)="updateObjective($event, item)" *ngIf="item.canUpdate">
                            <i class="far fa-fw fa-edit fs-5 accent-icon me-3"></i>
                          </a>
                          <button class="cursor-pointer table-icon-link" (click)="!editMode ? deleteObjective($event, item) : ''" ngbTooltip="{{ 'delete' | label : 'general' | async }}" placement="top" container="body" [disableTooltip]="editMode" *ngIf="settings.allowDevelopmentGoalsDelete" [disabled]="editMode">
                            <i class="far fa-fw fa-trash-alt fs-5 delete-icon"></i>
                          </button>
                        </div>
                      </div>

                      <div class="collapse-content mt-4" [class.expanded]="isObjectiveExpanded(item.studentIdpActivityId)">
                        <div class="d-flex align-items-center" [class.mt-3]="isObjectiveExpanded(item.studentIdpActivityId)">
                          <app-profile-picture class="mx-2" [title]="item.creator" [text]="item.creator" [whoId]="item.createdById" [whoKind]="item.createdByType" [width]="20"></app-profile-picture>
                          <div class="ms-3">
                            {{ item.creator }} {{ 'on' | label : 'learnpathEssDetail' | async }}
                            {{ item.createDate | employeeDate | async }}
                          </div>
                        </div>

                        <ng-container *ngTemplateOutlet="mobileItemFields; context: { $implicit: item, editing: editMode && activeObjective?.studentIdpActivityId == item.studentIdpActivityId }"></ng-container>

                        <div *ngIf="editMode && activeObjective?.studentIdpActivityId == item.studentIdpActivityId" class="text-end mt-4">
                          <button type="button" class="btn btn-cancel" (click)="cancelObjectiveChanges(activeObjective)" style="background-color: transparent !important">
                            {{ 'cancel' | label : 'general' | async }}
                          </button>
                          <button type="button" class="btn btn-progreso" (click)="saveObjectiveChanges(activeObjective)">
                            {{ 'save' | label : 'general' | async }}
                          </button>
                        </div>

                        <hr class="mt-4 mb-4" *ngIf="!editMode" />
                        <ng-container *ngTemplateOutlet="commentSection; context: { $implicit: item }"></ng-container>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </ng-container>
          </ng-container>

          <!-- Inactive employees -->
          <div *ngIf="inactiveObjectiveContractWrapper?.length" style="margin-top: 60px">
            <h1>{{ 'inactive_employees' | label : 'development_objectives' | async }}</h1>
            <ng-container *ngFor="let contract of inactiveObjectiveContractWrapper">
              <div *ngIf="contract.items?.length; else noresults">
                <div class="mb-4 mt-4">
                  <h2>{{ contract.firstName }} {{ contract.lastName }}</h2>
                  <span>{{ contract.functionName }} - {{ contract.departmentName }} ({{ contract.companyName }})</span>
                </div>

                <!-- DESKTOP: Inactive table -->
                <table class="table d-none d-lg-table" [ngClass]="smallLayout ? 'smallLayout' : ''">
                  <thead>
                    <tr class="table_header_objectives">
                      <th class="objective_name">{{ 'name' | label : 'general' | async }}</th>
                      <th class="objective_status">{{ 'status' | label : 'general' | async }}</th>
                      <th class="objective_due_date">{{ 'due_date' | label : 'goals' | async }}</th>
                      <th class="objective_create_by_on" *ngIf="!smallLayout">{{ 'create_by_on' | label : 'goals' | async }}</th>
                      <th class="objective_actions"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="let item of contract.items">
                      <tr (click)="!editMode ? openObjectiveDetail(item) : ''" *ngIf="!editMode || activeObjective?.studentIdpActivityId != item?.studentIdpActivityId" [ngClass]="{ 'active-row': item?.studentIdpActivityId == activeObjective?.studentIdpActivityId, editmode: editMode }">
                        <td class="text-truncate objective_name" [title]="item.name">{{ item.name }}</td>
                        <td class="objective_status">
                          <span class="badge" style="background-color: #c3c3c3">
                            {{ getStatusName(item.status) | label : 'objective_widget' | async }}
                          </span>
                        </td>
                        <td class="objective_due_date">
                          <span>{{ item.dueDate | employeeDate | async }}</span>
                        </td>
                        <td *ngIf="!smallLayout" class="objective_create_by_on">
                          <div class="d-flex align-items-center">
                            <app-profile-picture class="mx-2" [text]="item.creator" [whoId]="item.createdById" [whoKind]="item.createdByType" [width]="20"></app-profile-picture>
                            <div class="ms-3">
                              <span>{{ item.createDate | employeeDate | async }}</span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>

                <!-- MOBILE: Inactive cards -->
                <div class="d-lg-none">
                  <ng-container *ngFor="let item of contract.items">
                    <div class="card card--widget mb-3">
                      <div class="card-body p-3">
                        <div class="d-flex justify-content-between align-items-center" (click)="toggleCollapseObjective(item.studentIdpActivityId, item)">
                          <div class="d-flex align-items-center">
                            <i
                              class="far fa-fw me-3 cursor-pointer transition"
                              [ngClass]="{
                                'fa-minus-square': isObjectiveExpanded(item.studentIdpActivityId),
                                'fa-plus-square': !isObjectiveExpanded(item.studentIdpActivityId)
                              }"
                              (click)="toggleCollapseObjective(item.studentIdpActivityId, item); $event.stopPropagation()"
                            ></i>
                            <h2 class="text-truncate mb-0" style="font-size: 13px; max-width: 220px">{{ item.name | slice : 0 : 32 }}{{ item.name.length > 32 ? '...' : '' }}</h2>
                          </div>
                        </div>
                        <div class="collapse-content mt-4" [class.expanded]="isObjectiveExpanded(item.studentIdpActivityId)">
                          <div class="d-flex align-items-center" [class.mt-3]="isObjectiveExpanded(item.studentIdpActivityId)">
                            <app-profile-picture class="mx-2" [text]="item.creator" [whoId]="item.createdById" [whoKind]="item.createdByType" [width]="20"></app-profile-picture>
                            <div class="ms-3">
                              <span>{{ item.creator }} {{ 'on' | label : 'learnpathEssDetail' | async }} {{ item.createDate | employeeDate | async }}</span>
                            </div>
                          </div>
                          <ng-container *ngTemplateOutlet="mobileItemFields; context: { $implicit: item, editing: false, inactive: true }"></ng-container>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </div>
        </div>

        <!-- Detail panel (desktop only) -->
        <div class="col-lg-4 d-none d-lg-block">
          <div *ngIf="objectiveContractWrapper && objectiveContractWrapper.length" [ngClass]="{ smaller: _studentId != currentStudentId || whoisKind != 3 }">
            <div *ngIf="activeObjective" class="active-objective" [ngClass]="smallLayout ? 'smallLayout' : ''">
              <div *ngIf="editMode" class="text-end">
                <button type="button" class="btn btn-cancel" (click)="cancelObjectiveChanges(activeObjective)" style="background-color: transparent !important">
                  {{ 'cancel' | label : 'general' | async }}
                </button>
                <button type="button" class="btn btn-progreso" (click)="saveObjectiveChanges(activeObjective)">
                  {{ 'save' | label : 'general' | async }}
                </button>
              </div>
              <div class="row g-3">
                <div class="col-md-12">
                  <h2 style="font-size: 16px" *ngIf="!editMode">{{ activeObjective.name }}</h2>
                  <label class="form-label" *ngIf="editMode">{{ 'name' | label : 'general' | async }}</label>
                  <input class="form-control" *ngIf="editMode" type="text" [(ngModel)]="activeObjective.name" />
                </div>
                <div class="col-md-12">
                  <div class="d-flex align-items-center">
                    <app-profile-picture [title]="activeObjective.creator" [text]="activeObjective.creator" [whoId]="activeObjective.createdById" [whoKind]="activeObjective.createdByType" [width]="30"></app-profile-picture>
                    <div class="ms-3">
                      {{ activeObjective.creator }} {{ 'on' | label : 'learnpathEssDetail' | async }}
                      {{ activeObjective.createDate | employeeDate | async }}
                    </div>
                  </div>
                </div>
                <div class="col-md-12" *ngIf="activeObjective.actions || editMode">
                  <label class="form-label">{{ 'description' | label : 'goals' | async }}</label>
                  <div class="form-control pre-line" *ngIf="!editMode">{{ activeObjective.actions }}</div>
                  <textarea class="form-control" rows="5" [style.resize]="'none'" *ngIf="editMode" [(ngModel)]="activeObjective.actions"></textarea>
                </div>
                <div class="col-md-12" *ngIf="activeObjective.when || editMode">
                  <label class="form-label">{{ 'when' | label : 'development_objectives' | async }}</label>
                  <div class="form-control pre-line" *ngIf="!editMode">{{ activeObjective.when }}</div>
                  <textarea class="form-control" rows="5" [style.resize]="'none'" *ngIf="editMode" [(ngModel)]="activeObjective.when"></textarea>
                </div>
                <div class="col-md-12" *ngIf="activeObjective.measurement || editMode">
                  <label class="form-label">{{ 'measurement' | label : 'development_objectives' | async }}</label>
                  <div class="form-control pre-line" *ngIf="!editMode">{{ activeObjective.measurement }}</div>
                  <textarea class="form-control" rows="5" [style.resize]="'none'" *ngIf="editMode" [(ngModel)]="activeObjective.measurement"></textarea>
                </div>

                <div *ngIf="settings.attachCourseToGoals && coursesAvailable && (activeObjective.courseId || editMode)" [ngClass]="editMode ? 'col-md-12 mb-3' : 'col-lg-6'">
                  <div class="row">
                    <div class="col-md-12">
                      <label class="form-label" style="margin-right: 15px" [ngClass]="{ 'fw-bold': !editMode }">
                        {{ 'link_to_course' | label : 'development_objectives' | async }}
                      </label>
                      <button *ngIf="editMode" type="button" appBasicSelect [modalTitle]="'choose_course' | label : 'development_objectives' | async" [idProperty]="'id'" [displayProperties]="[{ property: 'name', display: 'course' | label : 'general' | async }]" [itemEndPoint]="'all_courses'" [countEndPoint]="'count_courses'" [selectedItems]="[{ id: activeObjective.courseId }]" (confirmed)="selectedCourse($event)" [endPointId]="" [multiSelect]="false" [centered]="false" class="btn btn-sm">+ {{ 'course' | label : 'general' | async }}</button>
                    </div>
                  </div>
                  <p *ngIf="activeObjective.courseId">
                    {{ activeObjective.courseName }}
                    <i class="fas fa-trash-alt delete-icon cursor-pointer ms-3" *ngIf="editMode" (click)="activeObjective.courseId = 0; activeObjective.courseName = ''"></i>
                  </p>
                </div>

                <div *ngIf="settings.developmentObjectivesLinkSkills && settings.developmentObjectivesLinkSkills > 0 && (activeObjective.competencyId || editMode)" [ngClass]="editMode ? 'col-md-12 mb-3' : 'col-lg-6'">
                  <div class="row">
                    <div class="col-md-12">
                      <label class="form-label" style="margin-right: 15px" [ngClass]="{ 'fw-bold': !editMode }">
                        {{ 'link_to_competence' | label : 'development_objectives' | async }}
                      </label>
                      <button
                        *ngIf="editMode"
                        type="button"
                        appBasicSelect
                        [modalTitle]="'choose_competence' | label : 'development_objectives' | async"
                        [idProperty]="'id'"
                        [displayProperties]="[
                          { property: 'longName', display: 'competence' | label : 'general' | async },
                          { property: 'clusterName', display: 'cluster' | label : 'general' | async },
                          { property: 'categoryName', display: 'category' | label : 'general' | async }
                        ]"
                        [itemEndPoint]="'competences_fordevgoals'"
                        [countEndPoint]="'countcompetences_fordevgoals'"
                        [selectedItems]="[{ id: objectiveEditing.competencyId }]"
                        (confirmed)="selectedCompetency($event)"
                        [endPointId]=""
                        [multiSelect]="false"
                        [extraEndpointData]="{ functionId: student.function?.id, basedOnFunction: settings.developmentObjectivesLinkSkills == 2 }"
                        [centered]="false"
                        class="btn btn-sm"
                      >
                        + {{ 'competence' | label : 'general' | async }}
                      </button>
                    </div>
                  </div>
                  <p *ngIf="activeObjective.competencyId">
                    {{ activeObjective.competencyName }}
                    <i class="fas fa-trash-alt delete-icon cursor-pointer ms-3" *ngIf="editMode" (click)="activeObjective.competencyId = 0; activeObjective.competencyName = ''"></i>
                  </p>
                </div>

                <div *ngIf="editMode" class="text-end">
                  <button type="button" class="btn btn-cancel" (click)="cancelObjectiveChanges(activeObjective)" style="background-color: transparent !important">
                    {{ 'cancel' | label : 'general' | async }}
                  </button>
                  <button type="button" class="btn btn-progreso" (click)="saveObjectiveChanges(activeObjective)">
                    {{ 'save' | label : 'general' | async }}
                  </button>
                </div>

                <hr class="mt-4 mb-4" *ngIf="!editMode || activeObjective?.comments" />
                <ng-container *ngTemplateOutlet="commentSection; context: { $implicit: activeObjective }"></ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #noresults>
  <p>{{ 'no_results' | label : 'objective_widget' | async }}</p>
</ng-template>

<!-- Reusable: mobile item fields -->
<ng-template #mobileItemFields let-item let-editing="editing" let-inactive="inactive">
  <div class="row" [class.mt-4]="isObjectiveExpanded(item.studentIdpActivityId)">
    <div class="col-4">
      <p>
        <strong>{{ 'name' | label : 'general' | async }}</strong>
      </p>
    </div>
    <div class="col-8">
      <span *ngIf="!editing">{{ item.name }}</span>
      <input class="form-control" *ngIf="editing" type="text" [(ngModel)]="activeObjective.name" />
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-4">
      <p>
        <strong>{{ 'status' | label : 'general' | async }}</strong>
      </p>
    </div>
    <div class="col-8">
      <select *ngIf="editing" name="status" class="form-select" [(ngModel)]="activeObjective.status" required>
        <option [ngValue]="1">{{ 'not_started' | label : 'objective_widget' | async }}</option>
        <option [ngValue]="2">{{ 'started' | label : 'objective_widget' | async }}</option>
        <option [ngValue]="3">{{ 'finished' | label : 'objective_widget' | async }}</option>
      </select>
      <span *ngIf="!editing">{{ getStatusName(item.status) | label : 'objective_widget' | async }}</span>
    </div>
  </div>
  <div class="row mt-3" *ngIf="item.actions || editing">
    <div class="col-4">
      <p>
        <strong>{{ 'description' | label : 'goals' | async }}</strong>
      </p>
    </div>
    <div class="col-8">
      <textarea class="form-control" rows="5" [style.resize]="'none'" *ngIf="editing" [(ngModel)]="activeObjective.actions"></textarea>
      <span *ngIf="!editing">{{ item.actions }}</span>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-4">
      <p>
        <strong>{{ 'due_date' | label : 'goals' | async }}</strong>
      </p>
    </div>
    <div class="col-8">
      <span *ngIf="!editing">{{ item.dueDate | employeeDate | async }}</span>
      <app-datepicker *ngIf="editing" [date]="activeObjective.dueDate" (dateChange)="activeObjective.dueDate = $event" [label]="'due_date' | label : 'goals' | async" [inline]="false" [simple]="false" [marginBottom]="false"></app-datepicker>
    </div>
  </div>
  <div class="row mt-3" *ngIf="item.when || editing">
    <div class="col-4">
      <p>
        <strong>{{ 'when' | label : 'development_objectives' | async }}</strong>
      </p>
    </div>
    <div class="col-8">
      <textarea class="form-control" rows="5" [style.resize]="'none'" *ngIf="editing" [(ngModel)]="activeObjective.when"></textarea>
      <span *ngIf="!editing">{{ item.when }}</span>
    </div>
  </div>
  <div class="row mt-3" *ngIf="item.measurement || editing">
    <div class="col-4">
      <p>
        <strong>{{ 'measurement' | label : 'development_objectives' | async }}</strong>
      </p>
    </div>
    <div class="col-8">
      <textarea class="form-control" rows="5" [style.resize]="'none'" *ngIf="editing" [(ngModel)]="activeObjective.measurement"></textarea>
      <div *ngIf="!editing">{{ item.measurement }}</div>
    </div>
  </div>
  <ng-container *ngIf="!inactive">
    <div class="row mt-4" *ngIf="settings.attachCourseToGoals && coursesAvailable && (item.courseId || editing)">
      <div class="col-6">
        <p>
          <strong>{{ 'link_to_course' | label : 'development_objectives' | async }}:</strong>
        </p>
      </div>
      <div class="col-6">
        <button *ngIf="editing" type="button" appBasicSelect [modalTitle]="'choose_course' | label : 'development_objectives' | async" [idProperty]="'id'" [displayProperties]="[{ property: 'name', display: 'course' | label : 'general' | async }]" [itemEndPoint]="'all_courses'" [countEndPoint]="'count_courses'" [selectedItems]="[{ id: activeObjective.courseId }]" (confirmed)="selectedCourse($event)" [endPointId]="" [multiSelect]="false" [centered]="false" class="btn btn-sm">+ {{ 'course' | label : 'general' | async }}</button>
        <p *ngIf="activeObjective.courseId">
          {{ activeObjective.courseName }}
          <i class="fas fa-trash-alt delete-icon cursor-pointer ms-3" *ngIf="editing" (click)="activeObjective.courseId = 0; activeObjective.courseName = ''"></i>
        </p>
      </div>
    </div>
    <div class="row mt-4" *ngIf="settings.developmentObjectivesLinkSkills && settings.developmentObjectivesLinkSkills > 0 && (item.competencyId || editing)">
      <div class="col-6">
        <p>
          <strong>{{ 'link_to_competence' | label : 'development_objectives' | async }}:</strong>
        </p>
      </div>
      <div class="col-6">
        <button
          *ngIf="editing"
          type="button"
          appBasicSelect
          [modalTitle]="'choose_competence' | label : 'development_objectives' | async"
          [idProperty]="'id'"
          [displayProperties]="[
            { property: 'longName', display: 'competence' | label : 'general' | async },
            { property: 'clusterName', display: 'cluster' | label : 'general' | async },
            { property: 'categoryName', display: 'category' | label : 'general' | async }
          ]"
          [itemEndPoint]="'competences_fordevgoals'"
          [countEndPoint]="'countcompetences_fordevgoals'"
          [selectedItems]="[{ id: objectiveEditing.competencyId }]"
          (confirmed)="selectedCompetency($event)"
          [endPointId]=""
          [multiSelect]="false"
          [extraEndpointData]="{ functionId: student.function?.id, basedOnFunction: settings.developmentObjectivesLinkSkills == 2 }"
          [centered]="false"
          class="btn btn-sm"
        >
          + {{ 'competence' | label : 'general' | async }}
        </button>
        <p *ngIf="activeObjective.competencyId">
          {{ activeObjective.competencyName }}
          <i class="fas fa-trash-alt delete-icon cursor-pointer ms-3" *ngIf="editing" (click)="activeObjective.competencyId = 0; activeObjective.competencyName = ''"></i>
        </p>
      </div>
    </div>
  </ng-container>
</ng-template>

<!-- Reusable: comment section -->
<ng-template #commentSection let-objective>
  <div class="comments">
    <div class="row g-2 mb-5" *ngIf="!editMode && objectiveCommentAdding && !completedConversation">
      <div class="col-12">
        <textarea name="description" class="form-control" [(ngModel)]="objectiveCommentAdding.description" rows="4" [style.resize]="'none'" placeholder="{{ 'add_comment' | label : 'goals' | async }}..."></textarea>
      </div>
      <div class="col-md-12" *ngIf="settings.devGoalsAllowPrivateComments || settings.devGoalsAllowPrivateCommentsSharedWithinOwnRole || settings.devGoalsAllowPrivateCommentsSharedBetweenManagersOrHr || settings.devGoalsAllowSharedComments">
        <div class="d-flex">
          <div class="flex-grow-1 d-flex">
            <label for="commentVisibility" class="col-form-label me-4">{{ 'comment_visibility' | label : 'goals' | async }}</label>
            <select id="commentVisibility" class="form-select form-select-sm" [(ngModel)]="objectiveCommentAdding.commentKind">
              <option [ngValue]="CommentKind.PrivateComment" *ngIf="settings.devGoalsAllowPrivateComments">
                {{ 'comment_setting_1' | label : 'goals' | async }}
              </option>
              <ng-container *ngIf="!isEmployee">
                <ng-container *ngIf="settings.devGoalsAllowPrivateCommentsSharedWithinOwnRole">
                  <option *ngIf="isCHR" [ngValue]="CommentKind.PrivateCommentSharedWithinOwnRole">
                    {{ 'private_comment_shared_with_others_hr_1' | label : 'goals' | async }}
                  </option>
                  <option *ngIf="isLHR" [ngValue]="CommentKind.PrivateCommentSharedWithinOwnRole">
                    {{ 'private_comment_shared_with_others_hr_2' | label : 'goals' | async }}
                  </option>
                  <option *ngIf="isSupervisor" [ngValue]="CommentKind.PrivateCommentSharedWithinOwnRole">
                    {{ 'private_comment_shared_with_others_1' | label : 'goals' | async }}
                  </option>
                  <option *ngIf="isDelegate" [ngValue]="CommentKind.PrivateCommentSharedWithinOwnRole">
                    {{ 'private_comment_shared_with_others_2' | label : 'goals' | async }}
                  </option>
                  <option *ngIf="isMatrixManager" [ngValue]="CommentKind.PrivateCommentSharedWithinOwnRole">
                    {{ 'private_comment_shared_with_others_3' | label : 'goals' | async }}
                  </option>
                  <option *ngIf="isN2" [ngValue]="CommentKind.PrivateCommentSharedWithinOwnRole">
                    {{ 'private_comment_shared_with_others_4' | label : 'goals' | async }}
                  </option>
                </ng-container>

                <ng-container *ngIf="settings.devGoalsAllowPrivateCommentsSharedBetweenManagersOrHr">
                  <option *ngIf="isCHR" [ngValue]="CommentKind.PrivateCommentSharedBetweenManagersOrHr">
                    {{ 'comment_setting_shared_with_HR_1' | label : 'goals' | async }}
                  </option>

                  <option *ngIf="isLHR" [ngValue]="CommentKind.PrivateCommentSharedBetweenManagersOrHr">
                    {{ 'comment_setting_shared_with_HR_2' | label : 'goals' | async }}
                  </option>

                  <option *ngIf="isSupervisor" [ngValue]="CommentKind.PrivateCommentSharedBetweenManagersOrHr">
                    {{ 'comment_setting_shared_with_manager_1' | label : 'goals' | async }}
                  </option>

                  <option *ngIf="isDelegate" [ngValue]="CommentKind.PrivateCommentSharedBetweenManagersOrHr">
                    {{ 'comment_setting_shared_with_manager_2' | label : 'goals' | async }}
                  </option>
                  <option *ngIf="isMatrixManager" [ngValue]="CommentKind.PrivateCommentSharedBetweenManagersOrHr">
                    {{ 'comment_setting_shared_with_manager_3' | label : 'goals' | async }}
                  </option>

                  <option *ngIf="isN2" [ngValue]="CommentKind.PrivateCommentSharedBetweenManagersOrHr">
                    {{ 'comment_setting_shared_with_manager_4' | label : 'goals' | async }}
                  </option>
                </ng-container>
              </ng-container>
              <option [ngValue]="CommentKind.SharedComment" *ngIf="settings.devGoalsAllowSharedComments">
                {{ 'comment_setting_4' | label : 'goals' | async }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-12 d-flex justify-content-end mt-3">
        <button class="btn btn-sm ms-3" (click)="addComment(objective)" [disabled]="!objectiveCommentAdding.description || objectiveCommentAdding.description.length == 0">
          {{ 'save' | label : 'general' | async }}
        </button>
      </div>
    </div>

    <div class="comment-list">
      <div class="row g-3">
        <ng-container *ngFor="let comment of objective.comments">
          <div class="col-12" *ngIf="checkWhoCanSeeComment(comment)">
            <div class="comment position-relative" [ngClass]="{ changelog: comment.commentType == 9 }">
              <div class="comment-creator">
                <div class="d-flex">
                  <div class="position-relative">
                    <app-profile-picture [text]="comment.creatorName" [whoId]="comment.createdById" [whoKind]="comment.createdByType" [width]="30"></app-profile-picture>
                  </div>
                  <div class="ms-4 min-w-0">
                    <div class="name-creator fw-bold">{{ comment.creatorName }}</div>
                    <ng-container *ngIf="comment.title == null || comment.description == null">
                      <div class="comment-meta-row">
                        <i
                          class="fas private-comment"
                          [ngClass]="{
                            'fa-lock': comment.commentKind === CommentKind.PrivateComment,
                            'fa-lock-open': comment.commentKind != CommentKind.PrivateComment
                          }"
                          [ngbTooltip]="getCommentKindLabel(comment) | label : 'goals' | async"
                          placement="top"
                          container="body"
                        ></i>
                        <small class="text-muted" *ngIf="comment.commentKind == CommentKind.PrivateComment">
                          {{ 'comment_setting_1' | label : 'goals' | async }}
                        </small>
                        <small class="text-muted ellipsis-text" *ngIf="comment.commentKind == CommentKind.PrivateCommentSharedWithinOwnRole">
                          <!-- CHR -->
                          <ng-container *ngIf="isCHR">
                            {{ 'private_comment_shared_with_others_hr_1' | label : 'goals' | async }}
                          </ng-container>

                          <!-- LHR -->
                          <ng-container *ngIf="isLHR">
                            {{ 'private_comment_shared_with_others_hr_2' | label : 'goals' | async }}
                          </ng-container>

                          <!-- Manager -->
                          <ng-container *ngIf="isSupervisor && !isDelegate && !isMatrixManager && !isN2">
                            {{ 'private_comment_shared_with_others_1' | label : 'goals' | async }}
                          </ng-container>

                          <!-- Delegate manager -->
                          <ng-container *ngIf="isDelegate">
                            {{ 'private_comment_shared_with_others_2' | label : 'goals' | async }}
                          </ng-container>

                          <!-- Matrix manager -->
                          <ng-container *ngIf="isMatrixManager">
                            {{ 'private_comment_shared_with_others_3' | label : 'goals' | async }}
                          </ng-container>

                          <!-- N+2 manager -->
                          <ng-container *ngIf="isN2">
                            {{ 'private_comment_shared_with_others_4' | label : 'goals' | async }}
                          </ng-container>
                        </small>
                        <small class="text-muted ellipsis-text" *ngIf="comment.commentKind == CommentKind.PrivateCommentSharedBetweenManagersOrHr">
                          <ng-container *ngIf="isCHR">{{ 'comment_setting_shared_with_HR_1' | label : 'goals' | async }}</ng-container>
                          <ng-container *ngIf="isLHR">{{ 'comment_setting_shared_with_HR_2' | label : 'goals' | async }}</ng-container>
                          <ng-container *ngIf="isSupervisor && !isDelegate && !isMatrixManager && !isN2">{{ 'comment_setting_shared_with_manager_1' | label : 'goals' | async }}</ng-container>
                          <ng-container *ngIf="isDelegate">{{ 'comment_setting_shared_with_manager_2' | label : 'goals' | async }}</ng-container>
                          <ng-container *ngIf="isMatrixManager">{{ 'comment_setting_shared_with_manager_3' | label : 'goals' | async }}</ng-container>
                          <ng-container *ngIf="isN2">{{ 'comment_setting_shared_with_manager_4' | label : 'goals' | async }}</ng-container>
                        </small>
                        <small class="text-muted ellipsis-text" *ngIf="comment.commentKind == CommentKind.SharedComment">
                          {{ 'comment_setting_4' | label : 'goals' | async }}
                        </small>
                      </div>
                    </ng-container>
                    <div>
                      <small>{{ comment.createDate | employeeDate | async }}</small>
                    </div>
                    <div class="comment-content">
                      <div class="comment-name" [ngClass]="comment.commentType != 9 ? 'fw-bold' : 'text-decoration-underline'" *ngIf="comment.title">{{ comment.title }}</div>
                      <div [innerHTML]="comment.description"></div>
                    </div>
                  </div>
                </div>
              </div>
              <button class="btn btn-sm delete position-absolute comment-delete" (click)="deleteComment(comment)" *ngIf="(comment.createdByType == 2 ? 1 : comment.createdByType) == (whoisKind == 2 ? 1 : whoisKind) && (comment.commentType != 9 || settings.deletableChangeLog) && !completedConversation">
                <i class="fas fa-trash red-icon"></i>
              </button>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>

<!-- Add/Edit objective modal -->
<ng-template #addObjectiveModal let-modal>
  <div class="modal-header">
    <h2 *ngIf="!objectiveEditing.studentIdpActivityId" class="modal-title">
      {{ 'add_development_goal' | label : 'managerdashboard' | async }}
    </h2>
    <h2 *ngIf="objectiveEditing.studentIdpActivityId > 0" class="modal-title">
      {{ 'edit_development_goal' | label : 'development_objectives' | async }}
    </h2>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div [ngClass]="objectiveEditing.studentIdpActivityId > 0 ? 'col-lg-6' : 'col'">
        <div class="row g-3">
          <div [ngClass]="{ 'col-12': objectiveEditing.studentIdpActivityId > 0, 'col-lg-4': !objectiveEditing.studentIdpActivityId }">
            <label for="objectiveName" class="form-label">{{ 'name_goal' | label : 'goals' | async }} *</label>
            <input #name="ngModel" type="text" name="objectiveName" id="objectiveName" class="form-control" [(ngModel)]="objectiveEditing.name" required />
          </div>
          <div class="col-lg-4" *ngIf="!objectiveEditing.studentIdpActivityId">
            <label for="status" class="form-label">{{ 'status' | label : 'general' | async }} *</label>
            <select name="status" id="status" class="form-select" [(ngModel)]="objectiveEditing.status" required>
              <option [ngValue]="1">{{ 'not_started' | label : 'objective_widget' | async }}</option>
              <option [ngValue]="2">{{ 'started' | label : 'objective_widget' | async }}</option>
              <option [ngValue]="3">{{ 'finished' | label : 'objective_widget' | async }}</option>
            </select>
          </div>
          <div class="col-lg-4" *ngIf="!objectiveEditing.studentIdpActivityId">
            <app-datepicker [date]="objectiveEditing.dueDate" (dateChange)="objectiveEditing.dueDate = $event" [label]="'due_date' | label : 'goals' | async" [inline]="false" [simple]="false" [marginBottom]="false"></app-datepicker>
          </div>
          <div class="col-12">
            <label for="description" class="form-label">{{ 'description' | label : 'goals' | async }}</label>
            <textarea name="description" id="description" class="form-control" [(ngModel)]="objectiveEditing.actions" rows="5" [style.resize]="'none'"></textarea>
          </div>
          <div class="col-12">
            <label for="when" class="form-label">{{ 'when' | label : 'development_objectives' | async }}</label>
            <textarea name="when" id="when" class="form-control" [(ngModel)]="objectiveEditing.when" rows="5" [style.resize]="'none'"></textarea>
          </div>
          <div class="col-12">
            <label for="measurement" class="form-label">{{ 'measurement' | label : 'development_objectives' | async }}</label>
            <textarea name="measurement" id="measurement" class="form-control" [(ngModel)]="objectiveEditing.measurement" rows="5" [style.resize]="'none'"></textarea>
          </div>
          <div class="col-lg-4" *ngIf="!objectiveEditing.studentIdpActivityId && settings.attachCourseToGoals && coursesAvailable">
            <label class="form-label" style="margin-right: 15px">{{ 'link_to_course' | label : 'development_objectives' | async }}</label>
            <button type="button" appBasicSelect [modalTitle]="'choose_course' | label : 'development_objectives' | async" [idProperty]="'id'" [displayProperties]="[{ property: 'name', display: 'course' | label : 'general' | async }]" [itemEndPoint]="'all_courses'" [countEndPoint]="'count_courses'" [selectedItems]="[{ id: objectiveEditing.courseId }]" (confirmed)="selectedCourse($event)" [endPointId]="" [multiSelect]="false" [centered]="false" class="btn btn-sm">+ {{ 'course' | label : 'general' | async }}</button>
            <p *ngIf="objectiveEditing.courseId">
              {{ objectiveEditing.courseName }}
              <i class="fas fa-trash-alt delete-icon cursor-pointer ms-3" (click)="objectiveEditing.courseId = 0; objectiveEditing.courseName = ''"></i>
            </p>
          </div>
          <div class="col-lg-4" *ngIf="!objectiveEditing.studentIdpActivityId && settings.developmentObjectivesLinkSkills && settings.developmentObjectivesLinkSkills > 0">
            <label class="form-label" style="margin-right: 15px">{{ 'link_to_competence' | label : 'development_objectives' | async }}</label>
            <button
              type="button"
              appBasicSelect
              [modalTitle]="'choose_competence' | label : 'development_objectives' | async"
              [idProperty]="'id'"
              [displayProperties]="[
                { property: 'longName', display: 'competence' | label : 'general' | async },
                { property: 'clusterName', display: 'cluster' | label : 'general' | async },
                { property: 'categoryName', display: 'category' | label : 'general' | async }
              ]"
              [itemEndPoint]="'competences_fordevgoals'"
              [countEndPoint]="'countcompetences_fordevgoals'"
              [selectedItems]="[{ id: objectiveEditing.competencyId }]"
              (confirmed)="selectedCompetency($event)"
              [endPointId]=""
              [multiSelect]="false"
              [extraEndpointData]="{ functionId: student.function?.id, basedOnFunction: settings.developmentObjectivesLinkSkills == 2 }"
              [centered]="false"
              class="btn btn-sm"
            >
              + {{ 'competence' | label : 'general' | async }}
            </button>
            <p *ngIf="objectiveEditing.competencyId">
              {{ objectiveEditing.competencyName }}
              <i class="fas fa-trash-alt delete-icon cursor-pointer ms-3" (click)="objectiveEditing.competencyId = 0; objectiveEditing.competencyName = ''"></i>
            </p>
          </div>
        </div>
      </div>

      <!-- Edit mode extra column -->
      <div class="col-lg-6" *ngIf="objectiveEditing.studentIdpActivityId > 0">
        <div class="row g-3">
          <div class="col-lg-6">
            <label for="status" class="form-label">{{ 'status' | label : 'general' | async }} *</label>
            <select name="status" id="status" class="form-select" [(ngModel)]="objectiveEditing.status" required>
              <option [ngValue]="1">{{ 'not_started' | label : 'objective_widget' | async }}</option>
              <option [ngValue]="2">{{ 'started' | label : 'objective_widget' | async }}</option>
              <option [ngValue]="3">{{ 'finished' | label : 'objective_widget' | async }}</option>
            </select>
          </div>
          <div class="col-lg-6">
            <app-datepicker [date]="objectiveEditing.dueDate" (dateChange)="objectiveEditing.dueDate = $event" [label]="'due_date' | label : 'goals' | async" [inline]="false" [simple]="false" [marginBottom]="false"></app-datepicker>
          </div>
          <div class="col-lg-6" *ngIf="settings.attachCourseToGoals && coursesAvailable">
            <label class="form-label" style="margin-right: 15px">{{ 'link_to_course' | label : 'development_objectives' | async }}</label>
            <button type="button" appBasicSelect [modalTitle]="'choose_course' | label : 'development_objectives' | async" [idProperty]="'id'" [displayProperties]="[{ property: 'name', display: 'course' | label : 'general' | async }]" [itemEndPoint]="'all_courses'" [countEndPoint]="'count_courses'" [selectedItems]="[{ id: objectiveEditing.courseId }]" (confirmed)="selectedCourse($event)" [endPointId]="" [multiSelect]="false" [centered]="false" class="btn btn-sm">+ {{ 'course' | label : 'general' | async }}</button>
            <p *ngIf="objectiveEditing.courseId">
              {{ objectiveEditing.courseName }}
              <i class="fas fa-trash-alt delete-icon cursor-pointer ms-3" (click)="objectiveEditing.courseId = 0; objectiveEditing.courseName = ''"></i>
            </p>
          </div>
          <div class="col-lg-6" *ngIf="settings.developmentObjectivesLinkSkills && settings.developmentObjectivesLinkSkills > 0">
            <label class="form-label" style="margin-right: 15px">{{ 'link_to_competence' | label : 'development_objectives' | async }}</label>
            <button
              type="button"
              appBasicSelect
              [modalTitle]="'choose_competence' | label : 'development_objectives' | async"
              [idProperty]="'id'"
              [displayProperties]="[
                { property: 'longName', display: 'competence' | label : 'general' | async },
                { property: 'clusterName', display: 'cluster' | label : 'general' | async },
                { property: 'categoryName', display: 'category' | label : 'general' | async }
              ]"
              [itemEndPoint]="'competences_fordevgoals'"
              [countEndPoint]="'countcompetences_fordevgoals'"
              [selectedItems]="[{ id: objectiveEditing.competencyId }]"
              (confirmed)="selectedCompetency($event)"
              [endPointId]=""
              [multiSelect]="false"
              [extraEndpointData]="{ functionId: student.function?.id, basedOnFunction: settings.developmentObjectivesLinkSkills == 2 }"
              [centered]="false"
              class="btn btn-sm"
            >
              + {{ 'competence' | label : 'general' | async }}
            </button>
            <p *ngIf="objectiveEditing.competencyId">
              {{ objectiveEditing.competencyName }}
              <i class="fas fa-trash-alt delete-icon cursor-pointer ms-3" (click)="objectiveEditing.competencyId = 0; objectiveEditing.competencyName = ''"></i>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-cancel" (click)="modal.dismiss()">
      {{ 'cancel' | label : 'general' | async }}
    </button>
    <button type="button" class="btn btn-progreso" (click)="modal.close()" [disabled]="name.invalid">
      {{ 'save' | label : 'general' | async }}
    </button>
  </div>
</ng-template>
